<div class="body" style="overflow: auto">
  <!--Cards-->
  <br>
  <div class="card-deck">
      <!-- Row 0 -->
      <div class="row mx-auto justify-content-center" style="margin-top:5px;margin-bottom: 5px; width: 100%;">
          <!--MySite-->
          <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
              <img class="card-img-top" src="assets/img/allegheny-county-health-department-logo.jpg" alt="Sample" style="width:7rem;height:5rem;">
              <div class="card-body col text-center">
                  <h5 class="card-title">Pittsburgh Health Inspection Analysis 2025</h5>
                  <p class="card-text text-center">R Analysis of Restaurant Hygiene in Allegheny County</p>
                  <button id="btn_1" class="btn btn-info btn-primary"
                          onclick="getElementById('modal_5').style.display = 'block';">Details
                  </button>
              </div>
          </div>
          <!--Blog-->
          <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
              <img class="card-img-top " src="assets/img/covid19.png" alt="Sample"
                   style="width:5rem;height:5rem;">
              <div class="card-body col text-center">
                  <h5 class="card-title">My First Publication</h5>
                  <p class="card-text text-center">Identifying risk factors of post–COVID-19 conditions with machine learning and deep learning algorithms</p>
                  <button id="btn_10" class="btn btn-info btn-primary"
                          onclick="getElementById('modal_12').style.display = 'block';">Details
                  </button>
              </div>
          </div>
      </div>
    <!--Row1-->
    <div class="row mx-auto justify-content-center" style="margin-top:5px;margin-bottom: 5px; width: 100%;">
      <!--OAI Research-->
      <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
        <img class="card-img-top" src="assets/img/oai.png" alt="Sample"
             style="width:5rem;height:6rem;padding-block:1rem;">
        <div class="card-body col text-center">
          <h5 class="card-title">OAI Research</h5>
          <p class="card-text text-center">Research from my Master's Degree in Biostatistics</p>
          <button id="btn_9" class="btn btn-info btn-primary"
                  onclick="getElementById('modal_11').style.display = 'block';">Details
          </button>
        </div>
      </div>

      <!--WEMU-->
      <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
        <img class="card-img-top" src="assets/img/ibm.png" alt="Sample" style="width:6rem;height:5rem; margin-top: 10px">
        <div class="card-body col text-center">
          <h5 class="card-title">IBM AI Engineering Professional Certificate</h5>
          <p class="card-text text-center">Official IBM Machine Learning Certificate</p>
          <button id="btn_0" class="btn btn-info btn-primary"
                  onclick="getElementById('modal_7').style.display = 'block';">Details
          </button>
        </div>
      </div>
    </div>
    <!--Row 2-->
    <div class="row mx-auto justify-content-center" style="margin-top:5px;margin-bottom: 5px; width: 100%;">
      <!--MyBlog-->
      <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
        <img class="card-img-top" src="assets/img/MH_Logo.png" alt="Sample" style="width:5rem;height:5rem;">
        <div class="card-body col text-center">
          <h5 class="card-title">This Website</h5>
          <p class="card-text text-center">Angular 14 Frontend</p>
          <button id="btn_00" class="btn btn-info btn-primary"
                  onclick="getElementById('modal_8').style.display = 'block';">Details
          </button>
        </div>
      </div>

      <!--WEMU-->
      <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
        <img class="card-img-top" src="assets/img/WEMU-Logo.png" alt="Sample"
             style="width:5rem;height:5rem;">
        <div class="card-body col text-center">
          <h5 class="card-title">WEMU Music Catalog</h5>
          <p class="card-text text-center">Django CRUD web app with MySQL</p>
          <button id="btn_2" class="btn btn-info btn-primary"
                  onclick="getElementById('modal_6').style.display = 'block';">Details
          </button>
        </div>
      </div>
    </div>
    <!--Row 3-->
    <div class="row mx-auto justify-content-center" style="margin-top:5px;margin-bottom: 5px; width: 100%;">
      <!--Client Server-->
      <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
        <img class="card-img-top" src="assets/img/network.png" alt="Sample" style="width:7rem;height:5rem;">
        <div class="card-body col text-center">
          <h5 class="card-title">Stock Trading Client-Server Program</h5>
          <p class="card-text text-center">Socket programming in C</p>
          <button id="btn_3" class="btn btn-info btn-primary"
                  onclick="getElementById('modal_1').style.display = 'block';">Details
          </button>
        </div>
      </div>
      <!--Project3-->
      <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
        <img class="card-img-top " src="assets/img/dos.png " alt="Sample" style="width:5rem;height:5rem;">
        <div class="card-body col text-center">
          <h5 class="card-title">DOS-Like Operating System</h5>
          <p class="card-text text-center">A low-level OS using assembly</p>
          <button id="btn_4" class="btn btn-info btn-primary"
                  onclick="getElementById('modal_2').style.display = 'block';">Details
          </button>
        </div>
      </div>
    </div>
    <!--Row 4-->
    <div class="row mx-auto justify-content-center" style="margin-top:5px;margin-bottom: 5px; width: 100%;">
      <!--Bash Script-->
      <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
        <img class="card-img-top" src="assets/img/Terminal-512.png" alt="Sample"
             style="width:5rem;height:5rem;">
        <div class="card-body col text-center">
          <h5 class="card-title">Bash Document Sorting</h5>
          <p class="card-text text-center">A script I use for my desktop</p>
          <button id="btn_5" class="btn btn-info btn-primary"
                  onclick="getElementById('modal_3').style.display = 'block';">Details
          </button>
        </div>
      </div>
      <!--Project6-->
      <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
        <img class="card-img-top " src="assets/img/twitter_icon.png " alt="Sample"
             style="width:5rem;height:5rem;">
        <div class="card-body col text-center">
          <h5 class="card-title">Twitter Sentiment Analysis</h5>
          <p class="card-text text-center">Input a topic to find the sentiment of it on Twitter</p>
          <button id="btn_6" class="btn btn-info btn-primary"
                  onclick="getElementById('modal_4').style.display = 'block';">Details
          </button>
        </div>
      </div>
    </div>

    <!--Row 5-->
    <div class="row mx-auto justify-content-center" style="margin-top:5px;margin-bottom: 5px; width: 100%;">
      <!--Unraid Server-->
      <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
        <img class="card-img-top" src="assets/img/unraid.png" alt="Sample"
             style="width:5rem;height:5rem;">
        <div class="card-body col text-center">
          <h5 class="card-title">My Self-Hosted Server</h5>
          <p class="card-text text-center">An Unraid system I built and maintain from my apartment</p>
          <button id="btn_7" class="btn btn-info btn-primary"
                  onclick="getElementById('modal_9').style.display = 'block';">Details
          </button>
        </div>
      </div>
      <!--Bookstack-->
      <div class="card align-items-center bg-dark" style="max-width: 30rem; width: 100%;">
        <img class="card-img-top " src="assets/img/bookstack.png" alt="Sample"
             style="width:5rem;height:5rem;">
        <div class="card-body col text-center">
          <h5 class="card-title">My Notes</h5>
          <p class="card-text text-center">My notes made publicly available through BookStack</p>
          <button id="btn_8" class="btn btn-info btn-primary"
                  onclick="getElementById('modal_10').style.display = 'block';">Details
          </button>
        </div>
      </div>
    </div>

  </div>

  <!-- Modals -->
  <div id="modal_1" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Client-Server Stock Trading Program</h4>
        <span class="close" onclick="getElementById('modal_1').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>Languages: C, Makefile</p>
        <p>Description: A project I created for a Networking class I took. Select a stock and quantity and send
          the
          order through UDP and TCP connections with an RSA encryption scheme. See the readme on how to start
          the server and key manager.</p>
        <p align="center"><a href="https://github.com/Elkip/Networking_Prinipals" target="_blank">View Repository</a></p>
      </div>
    </div>
  </div>
  <div id="modal_2" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">DOS-Like Operating System</h4>
        <span class="close" onclick="getElementById('modal_2').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>Languages: NASM Assembly</p>
        <p>Description: Created for a class on the conceptual workings of operating systems. Implemented a
          low-level operating system using x86 instructions and BIOS calls.</p>
        <p align="center"><a href="https://github.com/Elkip/OS_assembly" target="_blank">View Repository</a></p>
      </div>
    </div>
  </div>
  <div id="modal_3" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Document Sorting Bash Script</h4>
        <span class="close" onclick="getElementById('modal_3').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>Languages: Bash</p>
        <p>Description: If your're like me, you might have a Desktop or Downloads folder full of various files
          that may or may not be important. This script is designed to sort those files based on their
          extension.
          It runs at startup via cron. It could easily be adapted to Windows Powershell.</p>
        <p align="center"><a href="https://github.com/Elkip/clean_downloads" target="_blank">View Repository</a></p>
      </div>
    </div>
  </div>
  <div id="modal_4" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Twitter Sentiment Analysis</h4>
        <span class="close" onclick="getElementById('modal_4').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>Languages: Python</p>
        <p>Description: Uses Text-Blob to find if a word is positive or negative and Twitter-Scraper to get the
          tweets pertaining to a topic without having to provide log-in credentials or an API key. <br><br>
        I have not touched this since the Elon changes so it no longer works!</p>
        <p align="center"><a href="https://github.com/Elkip/Tweet_Sentiment" target="_blank">View Repository</a></p>
      </div>
    </div>
  </div>
  <div id="modal_5" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Health Inspection Analysis</h4>
        <span class="close" onclick="getElementById('modal_5').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>Health reports are available to the public but there lacks a clear ranking system in Pittsburgh.</p>
        <p>I created a violation risk categorization system and ran an analysis of all restaurants in the area.</p>
        <p align="center"><a href="https://github.com/Elkip/West-PA-Health-Inspection-Analysis" target="_blank">View Repository</a></p>
      </div>
    </div>
  </div>
  <div id="modal_6" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">WEMU Music Catalog</h4>
        <span class="close" onclick="getElementById('modal_6').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>Languages: Python Django, HTML, CSS, JavaScript, SQL, Bash</p>
        <p>Description: My Undergraduate project I worked on for 2 semesters. Contained in an Amazon EC2
          instance, it has a django app connected to a MySQL database. Allows for search, input and deletion
          of music in the catalog. The first half of the project I exported the data from MS Access and
          designed the relational database with ER diagrams. In the second half of the project, I led a team
          of 4 students in
          building the web application using the Django frameworks.</p>
        <p align="center"><a href="https://github.com/Elkip/WEMU_App" target="_blank">View Repository</a></p>
      </div>
    </div>
  </div>
  <div id="modal_7" class="modal">
    <!-- Modal content -->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">IBM AI Engineering Professional Certificate</h4>
        <span class="close" onclick="getElementById('modal_7').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>A course I completed in 2020 about supervised and unsupervised machine learning algorithms and neural
          networks. Python libraries used include Keras, PyTorch, TensorFlow, Apache Spark, and SciKitLearn</p>
        <p><a href="https://www.coursera.org/professional-certificates/ai-engineer" target="_blank">Link to the Course</a></p>
      </div>
    </div>
  </div>
  <div id="modal_8" class="modal">
    <!-- Modal content -->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">This Site!</h4>
        <span class="close" onclick="getElementById('modal_8').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>Angular (TypeScript)</p>
        <p>This website has been an evolving project I've added to over the last 6 years. I used to be obsessed with
          doing everything from scratch and using my own databases, password encryption and login system, still available <a href="https://github.com/Elkip/BlogBackend" target="_blank">here</a>.
          I've since realized there's no need to reinvent the wheel. <br/>This site is also available on the
          <b>DARK WEB</b>: <br/>xizch7viowk34xcdfj3nyr4cpoq53raaivqygbzxf76t2gji7wm3v2qd.onion</p>
        <p align="center"><a href="https://github.com/Elkip/BlogFrontend" target="_blank">View Repository</a></p>
      </div>
    </div>
  </div>

  <div id="modal_9" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">My Self-Hosted Server</h4>
        <span class="close" onclick="getElementById('modal_9').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>While I was locked down during the pandemic I decided to start self-hosting an <a href="https://unraid.net/">Unraid</a>
          server from my apartment. It's taken a lot of time to maintain but it's been a worthwhile hobby. I run a various network
          file sharing services, a media server, a minecraft server, and much more.</p>
        <p><a href="https://lonelymountain.xyz" target="_blank">Visit The Lonely Mountain</a></p>
      </div>
    </div>
  </div>
  <div id="modal_10" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">My Bookstack</h4>
        <span class="close" onclick="getElementById('modal_10').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>After playing with many different note-taking apps I decided BookStack fits my needs best. I'm in the slow process
        of making all my notes open to anyone. It's hosted in the same cloud container as this site.</p>
        <p><a href="https://bookstack.mitchellhenschel.com" target="_blank">See My Notes</a></p>
      </div>
    </div>
  </div>
  <div id="modal_11" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Research From my Masters</h4>
        <span class="close" onclick="getElementById('modal_11').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>Research using data on the Osteoarthritis Initiative to analyze the characteristics of 4796 patients with or
          at risk of osteoarthritis, and compare those who had knee replacements to those who did not in R to determine
          patients most at risk for knee replacements using a multinomial logistic regression
          model with enumerated random forest clusters as the outcome.
          Unfortunately, my research advisor did not deliver on my expectations so I was never credited on a paper.</p>
        <p align="center"><a href="https://elkip.shinyapps.io/oai_app" target="_blank">View Shiny App</a></p>
      </div>
    </div>
  </div>
  <div id="modal_12" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Publication on the Effects of Long Covid</h4>
        <span class="close" onclick="getElementById('modal_12').style.display='none';">&times;</span>
      </div>
      <div class="modal-body">
        <p>Pfizer-sposnored study with use of machine learning and deep learning models to evaluate the progression and symptoms of 'Long Covid'</p>
        <p align="center"><a href="https://www.sciencedirect.com/science/article/pii/S2590113325000392" target="_blank">View Paper</a></p>
        <p>(If the link appears broken try adding https)</p>
      </div>
    </div>
  </div>
  <br><br><br>
</div>
<p></p>